<template>
  <div class="container nkn-logo-download-container">
    <div class="row nkn-logo-download-title">
      <h1 class="nkn-logo-download-title-text">Whitepaper</h1>
      <img class="nkn-title-under-line hidden-xs" v-lazy="'/static/logos/whatwedoline2x.png'" alt="">
      <img class="nkn-title-under-line-xs hidden-lg hidden-md hidden-sm visible-xs-12" v-lazy="'/static/logos/whatwedoline2x.png'" alt="">
    </div>
    <div class="row nkn-wp-download-content">
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
        <img v-lazy="'/static/img/pdfDown/Intro@2x.png'">
        <div class="wp-content">
          <div class="wp-content-title">NKN_Introduction_EN</div>
          <a href="/static/doc/NewKindofNetwork_EN.pdf" target="_blank" class="wp-content-download">download</a>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
        <img v-lazy="'/static/img/pdfDown/whitepaper@2x.png'">
        <div class="wp-content">
          <div class="wp-content-title">NKN_Whitepaper_EN</div>
          <a href="/static/doc/NKN_Whitepaper.pdf" target="_blank" class="wp-content-download">download</a>
        </div>
      </div>
    </div>
    <div class="row nkn-wp-download-content">
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
        <img v-lazy="'/static/img/pdfDown/Intro@2x.png'">
        <div class="wp-content">
          <div class="wp-content-title">NKN_Introduction_CN</div>
          <a href="/static/doc/NewKindofNetwork_ZH.pdf" target="_blank" class="wp-content-download">download</a>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
        <img v-lazy="'/static/img/pdfDown/whitepaper@2x.png'">
        <div class="wp-content">
          <div class="wp-content-title">NKN_Whitepaper_JP</div>
          <a href="/static/doc/NKN_whitepaper_JP.pdf" target="_blank" class="wp-content-download">download</a>
        </div>
      </div>
    </div>
    <div class="row nkn-wp-download-content">
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
        <img v-lazy="'/static/img/pdfDown/Intro@2x.png'">
        <div class="wp-content">
          <div class="wp-content-title">NKN_Introduction_KR</div>
          <a href="/static/doc/NKN_Whitepaper_KR.pdf" target="_blank" class="wp-content-download">download</a>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
        <img v-lazy="'/static/img/pdfDown/whitepaper@2x.png'">
        <div class="wp-content">
          <div class="wp-content-title">NKN_Whitepaper_RU</div>
          <a href="/static/doc/главная страница-  перевод.pdf" target="_blank" class="wp-content-download">download</a>
        </div>
      </div>
    </div>
    <div class="row nkn-wp-download-content">
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12 text-center">
        <img v-lazy="'/static/img/pdfDown/whitepaper@2x.png'">
        <div class="wp-content">
          <div class="wp-content-title">NKN_Whitepaper_ES</div>
          <a href="/static/doc/NKN_Whitepaper_ES.pdf" target="_blank" class="wp-content-download">download</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    if (this.$i18n.locale === 'zh') {
      return {
        title: 'NKN | 一种新网络',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        attribute: '',
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: 'NKN是一个去中心化，基于网络传输量工作证明，可支持千万级规模节点共识的区块链系统。'
          }
        ]
      }
    } else {
      return {
        title: 'Network Infrastructure Solutions | The New Kind of Network',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: 'Want to learn more about NKN? Read our in-depth solution to inefficient networks, blockchain centralization, and complex client-server models.'
          }
        ]
      }
    }

  },
}
</script>

<style lang="scss" scoped>
.nkn-wp-download-content{
  padding: 60px 0;
  img{
    width: 120px;height: 120px;
    @media screen and (max-width: 768px) {
      width: 100px;height: 100px;
      margin-top: 20px;
    }
  }
  .wp-content{
    display: inline-block;
    vertical-align: middle;
    margin-left: 30px;
    &-title{
      font-size: 18px;
      color: #253a7e;
      line-height: 60px;
    }
    &-download{
      display: block;
      width: 160px;line-height: 50px;
      font-size:18px;text-align: center;color: #253a7e;
      border: 1px solid currentColor;
      border-radius: 4px;
      text-decoration: none;

      &:hover{
        color: white !important;
        background: #253a7e;
      }
    }
  }

  & + & {
    border-top: 1px solid #e0e3ed;
  }
}
</style>

<style scoped>
.nkn-logo-download-container {
  max-width: 1170px;
}

.nkn-logo-download-container>.nkn-logo-download-title {
  margin-top: 80px;
  margin-bottom: 60px;
  text-align: center;
}

.nkn-logo-download-container>.nkn-logo-download-title>.nkn-logo-download-title-text {
  font-size: 24px;
  line-height: 24px;
  margin: 0 !important;
  color: #253a7e;
}

.nkn-title-under-line {
  height: 4px;
  width: 64px;
  margin-top: 20px;
}

.nkn-title-under-line-xs {
  height: 2px;
  width: 64px;
  margin-top: 20px;
}

.nkn-logo-download-container>.nkn-logo-container {
  padding: 0 15%;
  border-bottom: 1px solid #e0e3ed;
  display: flex;
  position: relative;
}

.nkn-logo-download-container>.nkn-logo-container>.nkn-logo {
  text-align: center;
  height: 300px;
  line-height: 300px;
  min-width: 256px;
}
</style>






// WEBPACK FOOTER //
// src/views/WpDownload.vue